module.exports = {
	"firstName": "rachel",
	"name": "urban traveller",
	"shortname": "urban-traveller",
	"website_handle": "urbantravellerr.com",
	"website_url": "http://www.urbantravellerr.com/",
	"instagram_handle": "urbantraveller",
	"instagram_url": "https://www.instagram.com/urbantraveller/",
	"description": "Urban Traveller, aka Rachel Ecclestone, is a photographer and freelance Social Media Manager based in Amsterdam, The Netherlands. This creative girl is as passionate about international food as she is about eclectic fashion which resonates in her sense of style. Her aim is to inspire others while still discovering more on herself.",
	"interview": [
		{
			"title": "1. How does this collection portray your personal style?",
			"description": "This collection portrays my love of the comfy, warm and layerable clothing, alongside clean cut lines and the Scandinavian minimalism. They're clothes one can use to add a little edge to any outfit, and are just extremely practical - an extra little bonus!"
		},
		{
			"title": "2. What is the coolest item in your closet?",
			"description": "The coolest item in my closet has to be my second hand Harley Davidson jacket that I bought when I was 16 for 30 NOK (about €3) in Stavanger, Norway, where I was living. It's still with me today, and is one of my most sentimental, and coolest pieces I own. It's kept me warm in the coldest and darkest of Norwegian winters and has probably seen a few too many house parties."
		},
		{
			"title": "3. Books or movies?",
			"description": "I'm definitely a huge book fan, as when I'm home I love being an introvert. There's something a lot more calming and satisfying to me to be lying on the couch with a cup of steaming tea and a thought provoking book than watching a movie. Don't get me wrong, I love movies, but for me they're best for when you're hanging out with friends or have someone to spar with afterwards about the central ideas of the film."
		}
	],
	"quote": "Working with Noisy may and the other inspiring gals to make our dreams a reality was a truly engaging, fun and inspiring journey",
	"media": [
		"/media/img/influencers/rachel/urban-traveller_slider-3.jpg",
		"/media/img/influencers/rachel/urban-traveller_slider-2.jpg",
		"/media/img/influencers/rachel/urban-traveller_slider-1.jpg",
		"/media/img/influencers/rachel/urban-traveller_slider-4.jpg"
	],
	"socialItems": [
		{
			"url": "https://www.instagram.com/p/BJdd7LejKHA/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/13671884_1263271887017428_2069548179_n.jpg?ig_cache_key=MTMyMzM0NTQ3NTYzODQzNjI4OA%3D%3D.2",
			"likes": 2709
		},
		{
			"url": "https://www.instagram.com/p/BMJsLX9BX0A/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14727624_599941026797615_5408771771778203648_n.jpg?ig_cache_key=MTM3MTgyMTg1NzE5MTU5MTE2OA%3D%3D.2",
			"likes": 3142
		},
		{
			"url": "https://www.instagram.com/p/BNHLJc_Btk_/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14624552_220092558414378_1891220932475748352_n.jpg?ig_cache_key=MTM4OTEyODAzODE3NjE4NDYzOQ%3D%3D.2",
			"likes": 4186
		},
		{
			"url": "https://www.instagram.com/p/BI-B0kXDYJ_/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/13694886_1739613886327479_1398522337_n.jpg?ig_cache_key=MTMxNDQ5NjE1MTczOTUzMTkwMw%3D%3D.2",
			"likes": 2994
		},
		{
			"url": "https://www.instagram.com/p/BMTwoL8BLfq/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14719724_1155838737842385_1299492361709027328_n.jpg?ig_cache_key=MTM3NDY1NjE3OTEwNzgzNzkzMA%3D%3D.2",
			"likes": 3267
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./data/influencers/urban-traveller.json
// module id = 79
// module chunks = 0